"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _home = _interopRequireDefault(require("@atlaskit/icon/core/home"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HomeCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.5 16H9a1 1 0 0 1-1-1v-4.946l3.28-3.379.021-.021a1 1 0 0 1 1.414.021L16 10.059V15a1 1 0 0 1-1 1h-1.5v-2.5a1.5 1.5 0 0 0-3 0zm7.5-3.936a1 1 0 0 0 1.215-1.564L14.15 5.282a3 3 0 0 0-4.242-.063l-.063.063L4.78 10.5A1 1 0 0 0 6 12.061V15a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
}, props, {
  newIcon: _home.default
}));
HomeCircleIcon.displayName = 'HomeCircleIcon';
var _default = exports.default = HomeCircleIcon;